<template>
  <Modal ref="modal">
    <MultiActivityInput v-model="activityIds" />

    <template #buttons>
      <button
        class="btn-secondary"
        :disabled="loading"
        @click="hide">
        Annuler
      </button>
      <button
        class="btn-primary"
        :class="{ 'loading': loading }"
        :disabled="loading"
        style="margin-left: 5px;"
        @click="submit">
        Enregistrer
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from "@/components/modals/Modal.vue";
import MultiActivityInput from "@/components/inputs/MultiActivityInput.vue";

export default {
  name: "EditContractActivitiesModal",
  components: {
    Modal,
    MultiActivityInput,
  },

  emits: ["change"],
  data() {
    return {
      contractId: null,
      activityIds: [],
      loading: false,
    };
  },
  methods: {
    show(contract) {
      this.contractId = contract.id;
      this.activityIds = contract.activities.map((activity) => activity.id);
      this.loading = false;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
      this.contractId = null;
      this.activityIds = null;
      this.loading = false;
    },
    submit() {
      this.loading = true;
      
      this.$services.contract.patch(
        this.contractId,
        {
          activity_ids: this.activityIds,
        },
      )
        .then((response) => {
          this.$emit(
            "change",
            {
              activities: response.data.activities,
              activity_ids: response.data.activity_ids,
            },
          );
          this.hide();
        });
    },
    
  },
};

</script>

<style lang="scss" scoped>


</style>